export default {
    namespaced: true,
    state: {
        major: {
            0: '',
            5: '01',
            6: '02',
            7: '03'
        },
        userItems: {
            pid: '',
            group: '',
            pwd: '',
            loginname: '',
            roles: 'NORMAL',
            rolesArr: ['NORMAL']
        },
        editedData: {}
    },
    getters: {},
    mutations: {
        SET_EDITEDDATA(state, options) {
            state.editedData = !options ? state.userItems : options;
        }
    },
    actions: {
        setEditedData(context, options) {
            context.commit('SET_EDITEDDATA', options);
        }
    }
};
